import { picoapp } from 'picoapp';

import accordion from '@/components/accordion';
import accountLogin from '@/components/accountLogin';
import announcementBar from '@/components/announcementBar';
import backToTop from '@/components/backToTop';
import blogFilter from '@/components/blogFilter';
import cartDrawer from '@/components/cartDrawer';
import cartDrawerItem from '@/components/cartDrawerItem';
import cookies from '@/components/cookies';
import customerAddresses from '@/components/customerAddresses';
import dropdown from './components/dropdown';
import header from '@/components/header';
import heroCarousel from '@/components/heroCarousel';
import loadMore from '@/components/loadMore';
import menu from '@/components/menu';
import mixAndMatch from '@/components/mixAndMatch';
import mobileNavigation from '@/components/mobileNavigation';
import newsletterForm from '@/components/newsletterForm';
import product from '@/components/product';
import productCard from './components/productCard';
import productCounter from '@/components/productCounter';
import productInformation from '@/components/productInformation';
import productRecommendations from '@/components/productRecommendations';
import productSelection from '@/components/product-selection';
import relatedArticles from '@/components/relatedArticles';
import textWithCarousel from '@/components/textWithCarousel';
import testimonial from '@/components/testimonial';
import quickAdd from '@/components/quickAdd';
import quiz from '@/components/quiz';
import productGallery from '@/components/productGallery';

const mqMobile = window.matchMedia('(max-width: 767px)');
const mqDesktop = window.matchMedia('(min-width: 1200px)');

const state = {
  cartOpen: false,
  navOpen: false,
  isMobile: mqMobile,
  isDesktop: mqDesktop,
  headerHeight: 192,
  showAnnouncement: false,
  quickAddProduct: {},
  quickAddTarget: null,
  quickAddFit: false,
};

const components = {
  accordion,
  accountLogin,
  announcementBar,
  backToTop,
  blogFilter,
  cartDrawer,
  cartDrawerItem,
  cookies,
  customerAddresses,
  dropdown,
  header,
  heroCarousel,
  loadMore,
  menu,
  mixAndMatch,
  mobileNavigation,
  newsletterForm,
  product,
  productCard,
  productCounter,
  productInformation,
  productRecommendations,
  quickAdd,
  quiz,
  relatedArticles,
  testimonial,
  textWithCarousel,
  productGallery,
  productSelection,

};

export default picoapp(components, state);
